import React, { Component } from 'react';
import view from '../../resources/images/estrategas/tools/view.svg';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, } from 'recharts';
import * as Request from '../../service/data-info-chart/requestsUtil';
import { NEW_BUSINESS_VISITS } from './../../utils/constants';
import del from '../../resources/images/estrategas/tools/trash.png';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';


class viewVisitsGraphNewBusiness extends Component {

  constructor(props) {
    super(props);
    this.displayListVisits = this.displayListVisits.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleVisitsRegister = this.toggleVisitsRegister.bind(this);
    this.toggleDelete = this.toggleDelete.bind(this);
    this.registerVisit = this.registerVisit.bind(this);
    this.validateVisit = this.validateVisit.bind(this);
    this.deleteVisit = this.deleteVisit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      startDate: moment(),
      modal: false,
      modalVisitsRegister: false,
      modalDelete: false,
    };
    this.appointments = '';
    this.visit = {
      id: 0,
      realDate: ''
    };
    this.id = 0;
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  toggleVisitsRegister() {
    this.setState({ modalVisitsRegister: !this.state.modalVisitsRegister });
  }

  toggleDelete(visit, id) {
    this.visit = visit;
    this.id = id;
    this.setState({ modalDelete: !this.state.modalDelete });
  }

  validateVisit() {
    if (this.props.lastVisitDay === '') {
      this.registerVisit();
    } else {
      let re = /-/g;
      let lastVisitDay = Number(this.props.lastVisitDay.replace(re,''));
      let newVisitDay = Number(moment(this.state.startDate).format('YYYYMMDD'));

      if (lastVisitDay < newVisitDay) {
        this.registerVisit();
      } else {
        alert('La fecha de la visita no puede ser registrada, debido a que es anterior a la fecha de la ultima visita.');
      }
    }
  }

  registerVisit() {
    let params = {
      businessId: this.props.id,
      realDate: moment(this.state.startDate)
        .format('YYYY/MM/DD')
    };
    Request.postFetch3(NEW_BUSINESS_VISITS, params)
      .then(resp => {
        this.props.callbackFromParent(Math.random());
      });
  }

  deleteVisit(id) {
    let params = {
      businessId: this.props.id,
      appointmentId: id
    };
    Request.deleteFetch(NEW_BUSINESS_VISITS, params)
      .then(resp => {
        this.props.callbackFromParent(Math.random());
      });
  }

  displayListVisits() {
    this.appointments = this.props.appointments.map((visit, id) => (
      <div className="d-flex justify-content-around mb-3" key={visit.id}>
        <h5>Vista {id + 1}</h5>
        <h5>{visit.realDate}</h5>
        <div className="notes-incidence-icon"><img src={del} alt=""
                                                   onClick={() => this.toggleDelete(visit, id + 1)}/>
        </div>
      </div>
    ));
  }

  displayContent() {
    let data = [];
    this.props.appointments.map((arr, id) => {
      data.push({
        name: 'Visita ' + (id + 1),
        real: arr.realDays,
        meta: arr.targetDays,
      });
    });

    if (this.props.appointments.length !== 0 && this.props.appointments.length !== undefined) {
      this.content =
        <div className="fix-legend">
          <BarChart
            width={700}
            height={350}
            data={data}
            margin={{
              top: 5,
              left: 5,
              bottom: 5,
              right: 5
            }}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis dataKey="name"/>
            <YAxis label={{
              value: 'Días',
              angle: -90,
              position: 'insideLeft'
            }}/>
            <Tooltip/>
            <Legend/>
            <Bar dataKey="real" fill="#8884d8"/>
            <Bar dataKey="meta" fill="#82ca9d"/>
          </BarChart>
        </div>;
    } else {
      this.content =
        <div className='container'><h4><b>Aun no hay visitas registradas para este negocio.</b></h4>
        </div>;
    }
  }

  render() {
    this.displayListVisits();
    this.displayContent();
    let button = this.props.authorization ?
      <Button color='primary' onClick={this.toggleVisitsRegister}>Gestionar
        visitas</Button> : '';
    return (
      <div>
        <div className='corrAct-view'>
          <div className="notes-incidence-icon" onClick={this.toggle}>
            <img src={view} alt=""/>
          </div>
          <Modal className='modal-lg' isOpen={this.state.modal} toggle={this.toggle}>
            <ModalHeader className="header-modal" toggle={this.toggle}>
              Visitas de {this.props.municipality} ( {this.props.operationType} )
            </ModalHeader>
            <ModalBody>
              <div className="d-flex justify-content-end">
                {button}
              </div>
              {this.content}

              <Modal className='modal-lg' isOpen={this.state.modalVisitsRegister}
                     toggle={this.toggleVisitsRegister}>
                <ModalHeader className="header-modal" toggle={this.toggleVisitsRegister}>
                  Visitas de {this.props.municipality} ( {this.props.operationType} )
                </ModalHeader>
                <ModalBody>
                  <div className="container text-center">
                    <h4 className='mb-4'><b>Visitas registradas:</b></h4>
                    {this.appointments}
                    <hr/>
                    <h4 className='mb-4'><b>Registrar nueva visita</b></h4>
                    <div className="d-flex justify-content-center">
                      <p className='mr-3'>Seleccione una fecha:</p>
                      <DatePicker
                        selected={this.state.startDate}
                        onChange={this.handleChange}
                        dateFormat='YYYY/MM/DD'
                      />
                    </div>
                    <Modal className='modal-lg' isOpen={this.state.modalDelete}
                           toggle={this.toggleVisitsRegister}>
                      <ModalHeader className="header-modal" toggle={this.toggleDelete}>
                      </ModalHeader>
                      <ModalBody>
                        ¿Desea eliminar la <b>visita {this.id}</b>? con fecha de
                        registro <b>{this.visit.realDate}</b> Si hay visitas posteriores a esta
                        registradas
                        también serán eliminadas
                      </ModalBody>
                      <ModalFooter>
                        <Button color='primary'
                                onClick={() => this.deleteVisit(this.visit.id)}>Eliminar</Button>{'  '}
                        <Button color="danger" onClick={this.toggleDelete}>Cancelar</Button>
                      </ModalFooter>
                    </Modal>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color='primary' onClick={this.validateVisit}>Registrar</Button>{'  '}
                  <Button color="danger" onClick={this.toggleVisitsRegister}>Cerrar</Button>
                </ModalFooter>
              </Modal>
            </ModalBody>
            <ModalFooter>
              <Button color="danger" onClick={this.toggle}>Cerrar</Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    );
  }

}

export default viewVisitsGraphNewBusiness;



// WEBPACK FOOTER //
// ./src/components/buttons/viewVisitsGraphNewBusiness.js